import { onMounted, onUnmounted } from 'vue';

export const useEventListener = (
    event: keyof WindowEventMap,
    callback: EventListener,
    target: EventTarget = window
) => {
    onMounted(() => target.addEventListener(event, callback));
    onUnmounted(() => target.removeEventListener(event, callback));
};
